import Block from '../block'

export default class ScrollButton extends Block {
    static title = 'scroll-button'

    init() {
        this.destination = this.element.dataset.destination
        this.element.addEventListener('click', () => this.scroll(this.destination))
    }

    scroll(destination) {
        if (destination.startsWith('#')) {
            const targetElement = document.querySelector(destination)
            if (!targetElement) {
                return
            }
            this.scrollToElement(targetElement)
            return
        }

        if (destination === 'top') {
            this.scrollToPosition(0)
            return
        }

        if (destination === 'bottom') {
            this.scrollToPosition(this.getDocumentHeight())
        }

        if (destination.startsWith('+')) {
            const y = Math.min(this.getScrollFromTop() + parseInt(destination.substr(1), 10), this.getDocumentHeight())
            this.scrollToPosition(y)
            return
        }

        if (destination.startsWith('-')) {
            this.scrollToPosition(this.getScrollFromTop() - parseInt(destination.substr(1), 10))
            return
        }

        if (parseInt(destination, 10) > 0) {
            this.scrollToPosition(destination)
        }
    }

    scrollToElement(el) {
        // Internet explorer
        if (window.document.documentMode) {
            el.scrollIntoView()
            return
        }

        el.scrollIntoView({
            behavior: 'smooth'
        })
    }

    scrollToPosition(y) {
        // Internet explorer
        if (window.document.documentMode) {
            window.scrollTo(0, y)
            return
        }

        window.scrollTo({
            top: y,
            left: 0,
            behavior: 'smooth'
        })
    }

    getScrollFromTop() {
        return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
    }

    getDocumentHeight() {
        return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
    }
}